/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
exporterVersion: 2.2.1
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import { useFrame } from '@react-three/fiber';

export default function Model(props) {
  const group = useRef()
  const { nodes, materials } = useGLTF('./Unity2Skfb.gltf')
  const mesh = useRef();
  useFrame(() => {
    mesh.current.rotation.y += 0.0075
  })

  return (
    <group ref={group} {...props} dispose={null} scale={5.0}>
      <mesh
        ref={mesh}
        geometry={nodes['node_Mountain3_-1129440'].geometry}
        material={materials.Rock}
        position={[-120,-115,-110]}
        rotation={[0, 0, 0]}
      />
    </group>
  )
}

useGLTF.preload('./Unity2Skfb.gltf')
